import {useCommonTranslation} from '@/i18n/hooks'

interface Props {
    className?: string
}

/**
 * Renders the brand icon (house + heart symbol). The light and dark variant are
 * toggled via Tailwind's `dark:` mechanism — the same color-scheme signal the
 * rest of the app relies on — instead of a duplicated media query. The
 * alternative text is i18n-aware; the hidden variant is removed from the
 * accessibility tree, so both images may safely carry the same alt text.
 *
 * Only the symbol is used: the horizontal word-mark's lettering renders too
 * small to read in the placements we have (navbar, login), so the legible
 * brand name is shown as adjacent text instead.
 */
export default function BrandLogo({className}: Props) {
    const {t} = useCommonTranslation()
    const alt = t('brand.logo.alt')
    const sizing = className ?? ''

    return (
        <>
            <img
                src="/vectors/icon_light.svg"
                alt={alt}
                className={`block dark:hidden ${sizing}`}
                data-testid="brand-logo-light"
            />
            <img
                src="/vectors/icon_dark.svg"
                alt={alt}
                className={`hidden dark:block ${sizing}`}
                data-testid="brand-logo-dark"
            />
        </>
    )
}
